import TODO from '../../../api/todo';

const state = {
  tasks: [],
  // taskTags: [],
  todoSearchQuery: '',
  todoFilter: null,
};
const getters = {

  queriedTasks: state => state.tasks.filter((task) => {
    let isItemOfCurrentFilter = false;

    if (
      state.todoFilter === 'all' && !task.is_trashed
      || state.todoFilter === 'important' && !task.is_trashed && task.is_important
      || state.todoFilter === 'starred' && !task.is_trashed && task.is_starred
      || state.todoFilter === 'completed' && !task.is_trashed && task.is_completed
      || state.todoFilter === 'trashed' && task.is_trashed
      // || task.tags.includes(state.todoFilter)

    ) { isItemOfCurrentFilter = true; }

    return isItemOfCurrentFilter && (task.title.toLowerCase().includes(state.todoSearchQuery.toLowerCase()) || task.content.toLowerCase().includes(state.todoSearchQuery.toLowerCase()));
  }),
  showTask: state => taskId => state.tasks.find((task) => task.id == taskId),
  // getTodosBySection: state => (sectionId) => state.todoArray.filter((task) => task.sectionId == sectionId),
};
const actions = {

  setTodoSearchQuery({ commit }, query) {
    commit('SET_TODO_SEARCH_QUERY', query);
  },
  index({ commit }, payload) {
    return new Promise((resolve, reject) => {
      TODO.index(payload)
        .then((response) => {
          commit('SET_TASKS', response.data);
          resolve(response);
        })
        .catch((error) => { reject(error); });
    });
  },

  // fetchTags({ commit }) {
  //
  //     commit('SET_TAGS',  [
  //         { id: 5,text: 'Frontend' ,value : 'frontend', color: 'primary' },
  //         { id: 7,text: 'Backend', value: 'backend', color: 'warning'},
  //         { id: 8,text: 'Doc', value: 'doc', color: 'success'},
  //         { id: 11,text: 'Bug', value: 'bug', color: 'danger' },
  //     ] );

  // return new Promise((resolve, reject) => {
  //     TODO.fetchTags()
  //         .then((response) => {
  //             commit('SET_TAGS', response.data)
  //             resolve(response)
  //         })
  //         .catch((error) => { reject(error) })
  // })
  // },

  storeTask({ commit, dispatch }, task) {
    return new Promise((resolve, reject) => {
      TODO.store(task)
        .then((response) => {
          // dispatch('index', { filter: 'all' });
          commit('ADD_TASK', Object.assign(task, { id: response.data.id }));
          resolve(response);
        })
        .catch((error) => { reject(error); });
    });
  },

  updateTask({ commit, dispatch }, task) {
    return new Promise((resolve, reject) => {
      TODO.update(task)
        .then((response) => {
          commit('UPDATE_TASK', response.data);
          // dispatch('index', { filter: 'all' });
          resolve(response);
        })
        .catch((error) => { reject(error); });
    });
  },
};
const mutations = {
  SET_TODO_SEARCH_QUERY(state, query) {
    state.todoSearchQuery = query;
  },
  UPDATE_TODO_FILTER(state, filter) {
    state.todoFilter = filter;
  },

  // API
  SET_TASKS(state, tasks) {
    if (tasks.pagination) {
      delete tasks.pagination;
    }
    state.tasks = Object.values(tasks);
  },
  // SET_TAGS(state, tags) {
  //     state.taskTags = tags
  // },
  ADD_TASK(state, task) {
    state.tasks.unshift(task);
  },
  UPDATE_TASK(state, task) {
    const taskIndex = state.tasks.findIndex((t) => t.id == task.id);
    Object.assign(state.tasks[taskIndex], task);
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
